<template>
  <div class="wrapper">
    <img v-if="downloadBanner != ''" :src="downloadBanner" class="backgroundImg">
    <img v-if="downloadBanner == ''" src="../assets/img/bg.png" class="backgroundImg">
    <!-- <table style="width: 100%">
      <tr>
        <td style="width: 20%"></td>
        <td style="width: 30%">
          <div class="img-box">
            <div id="downloadQrCode"></div>
            <p class="img-box-title">苹果 + 安卓端下载</p>
          </div>
        </td>
        <td style="width: 30%">
          <div class="img-box-second">
            <div id="downloadQrCodeSecond"></div>
            <p class="img-box-title">苹果TF版下载（防闪退）</p>
          </div>
        </td>
        <td style="width: 20%"></td>
      </tr>
    </table> -->
    <table style="width: 100%; margin-top: 350px; position: absolute; z-index: 1000;">
      <tr>
        <td style="width:25%">
          <div style="float: left; margin-left: 20%">
            <button class="buttonStyle" @click="showPopup('vueandrod')">
              <img src="../assets/img/Aandroid.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          <div style="float: left;margin-left: 20%">
            <button class="buttonStyle" @click="showPopup('nativeapp_ios')">
              <img src="../assets/img/aAPLE.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          <div style="float: left;margin-left: 20%">
            <button class="buttonStyle" @click="showPopup('windows')">
              <img src="../assets/img/aWINDOW.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          <div style="float: left;margin-left: 20%">
            <button class="buttonStyle" @click="showPopup('testflight')">
              <img src="../assets/img/aAPLETF.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
      </tr>
      <!-- =============================== second line ============================= -->
      <!-- <tr>
        <td style="width:25%">
          <div style="float: left; margin-left: 10%">
           <button class="buttonStyle" @click="showPopup('windows')">
              <img src="../assets/img/aWINDOW.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          <div style="float: left;">
            <button class="buttonStyle" @click="showPopup('mac')">
              <img src="../assets/img/AMac.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          
        </td>
      </tr> -->
      <!-- ================================ third line ================================ -->
      
    </table>
    <el-dialog id="dialogStyle" :visible.sync="qrPopup" width="450px" center>
      <div class="img-box">
        <div id="downloadQrCodeSecond"></div>
        <p class="img-box-title">{{ popupContent }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "download",
  data() {
    return {
      info: {
        qq: [],
        phone: [],
        codes: [],
      },
      appDownload: "",
      testFlightDownload: "",
      androidPro: "",
      appleFreeUpgrade: "",
      androidFreeUpgrade: "",
      nativeApp: "",
      qrPopup: false,
      popupContent: "",
      qrCode: null,
      pc_mac: "",
      pc_windows: "",
      hk_android: "",
      hk_apple: "",
      hk_apple_tf: "",
      downloadBanner: ""
    };
  },
  computed: {},
  methods: {
    showPopup(operate) {
      switch (operate) {
        case "testflight":
          this.qrPopup = true;
          this.popupContent = "苹果防闪退版";
          setTimeout(() => {
            this.QrCode(this.testFlightDownload);
          }, 300);
          break;
        case "vueandrod":
          this.qrPopup = true;
          this.popupContent = "安卓专业版";
          setTimeout(() => {
            this.QrCode(this.androidPro);
          }, 300);
          break;
        case "applefree":
          this.qrPopup = true;
          this.popupContent = "苹果免升级版";
          setTimeout(() => {
            this.QrCode(this.appleFreeUpgrade);
          }, 300);
          break;
        case "androidfree":
          this.qrPopup = true;
          this.popupContent = "安卓免升级版";
          setTimeout(() => {
            this.QrCode(this.androidFreeUpgrade);
          }, 300);
          break;
        case "nativeapp_android":
          this.qrPopup = true;
          this.popupContent = "安卓经典版";
          setTimeout(() => {
            this.QrCode(this.nativeApp);
          }, 300);
          break;
        case "nativeapp_ios":
          this.qrPopup = true;
          this.popupContent = "苹果经典版";
          setTimeout(() => {
            this.QrCode(this.nativeApp);
          }, 300);
          break;
        case "hkandroid":
          this.qrPopup = true;
          this.popupContent = "大牛港股安卓版";
          setTimeout(() => {
            this.QrCode(this.hk_android);
          }, 300);
          break;
        case "hkapple":
          this.qrPopup = true;
          this.popupContent = "大牛港股苹果版";
          setTimeout(() => {
            this.QrCode(this.hk_apple);
          }, 300);
          break;
        case "hkappletf":
          this.qrPopup = true;
          this.popupContent = "大牛港股苹果TF";
          setTimeout(() => {
            this.QrCode(this.hk_apple_tf);
          }, 300);
          break;
        case "mac":
          this.qrPopup = false;
          this.popupContent = "MAC桌面端";
          window.open(this.pc_mac)
          break;
        case "windows":
          this.qrPopup = false;
          this.popupContent = "Windows桌面端";
          window.open(this.pc_windows)
          break;

        default:
          break;
      }
    },
    QrCode(url) {
      if (this.qrCode) {
        this.qrCode.makeCode(url);
      } else {
        this.qrCode = new QRCode("downloadQrCodeSecond", {
          width: 345,
          height: 345,
          text: url, // 二维码地址
        });
      }
    },
    // QrCodeSecond(url) {
    //   new QRCode("downloadQrCodeSecond", {
    //     width: 345,
    //     height: 345,
    //     text: url,
    //   });
    // },
    getInfoData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "web_common",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.info = data;
            // that.QrCode(that.info.codes[0].code);
            that.appDownload = that.info.codes[0].code;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getQRLink() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "download_link",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // that.QrCodeSecond(res.data.data);
            that.testFlightDownload = res.data.data.iOS_testflight;
            that.androidPro = res.data.data.android_pro;
            that.appleFreeUpgrade = res.data.data.apple_free_upgrade;
            that.androidFreeUpgrade = res.data.data.android_free_upgrade;
            that.nativeApp = res.data.data.app_app;
            that.pc_mac = res.data.data.pc_mac;
            that.pc_windows = res.data.data.pc_windows;
            that.hk_android = res.data.data.hk_android;
            that.hk_apple = res.data.data.hk_apple;
            that.hk_apple_tf = res.data.data.hk_apple_tf;
            that.downloadBanner = res.data.data.downgrade_image;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    this.getInfoData();
    // this.QrCodeSecond();
    this.getQRLink();
  },
};
</script>

<style scoped>
.wrapper {
  /* background: url(../assets/img/bg.png) no-repeat center; */
  /* background-size: cover;
  background-position: 5% 70%; */
  min-width: 1000px;
  height: 720px;
  overflow: hidden;
  position: relative;
}

.backgroundImg{
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.img-box {
  width: 100%;
  opacity: 0.85;
  background: white;
  /* margin: 200px auto; */
  /* padding-top: 20px; */
}
.img-box img {
  width: 100%;
}
.img-box-title {
  text-align: center;
  font-size: 25px;
  padding: 28px 0px 0px 0px;
}

/*.img-box-second {
  width: 400px;
  opacity: 0.85;
  background: white;
  margin: 200px auto;
  padding-top: 20px;
}
.img-box-titl-second {
  text-align: center;
  font-size: 25px;
  padding: 10px 0;
} */

.tm-ic {
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  width: 40px;
  height: 40px;
}

.ffic-android {
  background-image: url(../assets/img/icons/ffic-android.png);
}

.ffic-iphone {
  background-image: url(../assets/img/icons/ffic-iphone.png);
}

.windows {
  background-image: url(../assets/img/icons/windows.png);
}

.mac {
  background-image: url(../assets/img/icons/mac.png);
}

.buttonStyle {
  display: flex;
  margin: 20px 0px;
  background-color: transparent;
}
</style>

<style>
#dialogStyle .el-dialog__body {
  padding: 25px 25px 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue